import { Component, OnInit, Inject } from '@angular/core';
import { Globals } from '../../../../globals'
import { IFormVisionHearing } from "../../../../Models/Forms/IFormVisionHearing";
import { FormVisionHearingService } from "../../../../Services/FormVisionHearingService";
import { IepService } from "../../../../Services/IepService";
import { ISpedStudentDemographics } from '../../../../Models/ISpedStudentDemographics'
import { IIepInstance } from '../../../../Models/IIepInstance'
import { Message } from 'primeng/primeng';
import { ILockStatus } from '../../../../Models/ILockStatus';
import { Router } from "@angular/router";
import { IReportParameter } from 'src/app/Models/IReportParameter';
import { SpinnerBase } from '../../../Base/SpinnerBase';
import { ReportService } from 'src/app/Services/ReportService';

@Component({
  selector: 'VisionHearing',
  templateUrl: './VisionHearing.component.html',
  styleUrls: ['./VisionHearing.component.css']
})

export class FormVisionHearingComponent extends SpinnerBase implements OnInit {
  _myGlobals: Globals;
  _baseUrl: string;
  _iepService: IepService;
  successMessages: Message[];
  errorMessages: Message[];
  studentInfo: ISpedStudentDemographics;
  selectedIepInstance: IIepInstance;
  isLocked: boolean;
  lockStatus: string;  
  canEditIep: boolean;
  saveClicked: boolean;
  visionHearingDB: any = [];
  reportParamArray: IReportParameter[];
  today: Date;
  //public showSpinner: boolean = false;

  constructor(
    private globals: Globals, reportService: ReportService,
    private _formVisionHearingService: FormVisionHearingService,
    iepService: IepService,
    @Inject('BASE_URL') baseUrl: string,
    public router: Router) {
      super(reportService);
    this._iepService = iepService;
    this._myGlobals = globals;
    this._baseUrl = baseUrl;
    this.studentInfo = this._myGlobals.spedStudentDemographics;
    this.selectedIepInstance = this._myGlobals.selectedIepInstance;
  }

  ngOnInit(): void {
    this.LoadFormVisionHearingDetails();
    this.isLocked = false;
    this.canEditIep = this._myGlobals.canEdit();
    this.successMessages = [];
    this.errorMessages = [];
    this.scrollToTop();
    this.today = new Date();
  }

  LoadFormVisionHearingDetails(): void {
    this._formVisionHearingService.getFormVisionHearing(this._myGlobals.selectedFormDetails.formId)
      .subscribe((res: IFormVisionHearing) => {
        this.visionHearingDB = res
        if (this.visionHearingDB.anticipatedDateofIepMeeting != null) {
          this.visionHearingDB.anticipatedDateofIepMeeting = new Date(this.visionHearingDB.anticipatedDateofIepMeeting);
        }
        if (this.visionHearingDB.visionScreeningDate != null) {
          this.visionHearingDB.visionScreeningDate = new Date(this.visionHearingDB.visionScreeningDate);
        }
        if (this.visionHearingDB.hearingScreeningDate != null) {
          this.visionHearingDB.hearingScreeningDate = new Date(this.visionHearingDB.hearingScreeningDate);
        }
        if (this.visionHearingDB.nurseSignatureDate != null) {
          this.visionHearingDB.nurseSignatureDate = new Date(this.visionHearingDB.nurseSignatureDate);
        }
      },
        err => console.error(err)
      );
  }

  clearMessages() {
    this.successMessages = [];
    this.errorMessages = [];
  }

  addMessage(msg: Message) {
    if (msg.severity == 'error') {
      this.errorMessages = [...this.errorMessages, msg];
    }
    else {
      this.successMessages = [...this.successMessages, msg];
    }
  }

  updateRadioButtonOptions() {
    if (this.visionHearingDB.visionStatusPassed == true) {
      this.visionHearingDB.visionStatusNotPassed = false
    }
    else {
      this.visionHearingDB.visionStatusNotPassed = true
    }
    if (this.visionHearingDB.hearingStatusPassed == true) {
      this.visionHearingDB.hearintStatusNotPassed = false
    }
    else {
      this.visionHearingDB.hearintStatusNotPassed = true
    }
  }

  //Save the Vision Hearing
  save(action) {
    this.scrollToTop();
    this.clearMessages();
    this.saveClicked = true;
    this.updateRadioButtonOptions();

    //update values
    this._formVisionHearingService.insertUpdateFormVisionHearing(this.visionHearingDB)
      .subscribe((res: IFormVisionHearing) => {
        let successMessage: Message = { severity: 'success', summary: 'Record Saved Successfully', detail: res.id.toString() }
        this.addMessage(successMessage);
        if (action == 'Close') {
          this.globals.editMode = false;
          this.loadUnLock("UnLock");
        }
        this.saveClicked = false;
        this.validateForm();
        this.LoadFormVisionHearingDetails();
      },
        (error) => {
          let errorMessage: Message = { severity: 'error', summary: 'Save Failed', detail: error };
          this.addMessage(errorMessage);
          this.saveClicked = false;
        }
      )
  }

  validateForm() {
    this._formVisionHearingService.validateForm(this._myGlobals.selectedFormDetails.formId)
      .subscribe((res: string[]) => {
        for (var item of res) {
          let errorMessage: Message = { severity: 'error', summary: 'Validation Error', detail: item };
          this.addMessage(errorMessage);
        }
      },
        err => console.error(err)
      );
  }

  loadUnLock(action) {
    this._iepService.lockUnlockForm(this._baseUrl + 'api/Iep/LockUnlockForm?formInstanceId='
      + this._myGlobals.selectedFormDetails.formInstanceId + '&action=' + action)
      .subscribe((res: ILockStatus) => {
        this.isLocked = res.success
        this.lockStatus = res.status
      },
        err => console.error(err)
      );
  }

  edit() {
    this.clearMessages();
    this.saveClicked = false;
    this._iepService.lockUnlockForm(this._baseUrl + 'api/Iep/LockUnlockForm?formInstanceId='
      + this._myGlobals.selectedFormDetails.formInstanceId + '&action=Lock')
      .subscribe((res: ILockStatus) => {
        this.isLocked = res.success
        this.lockStatus = res.status
        if (this.isLocked == true) {
          this.globals.editMode = true;
        }
        else {
          let failedMessage: Message = { severity: 'warn', summary: this.lockStatus }
          this.addMessage(failedMessage);
        }
      });
  }

  cancel() {
    this.clearMessages();
    this.globals.editMode = false;
    this.loadUnLock("UnLock");
    //this.router.navigate(['iep-ap']);
    this.LoadFormVisionHearingDetails();
  }

  populateReportParameters() {
    this.reportParamArray = [];
    this.reportParamArray.push(
      { parameterName: 'PlanAddendumID', parameterValue: '' },
      { parameterName: 'RequestID', parameterValue: '0' },
      { parameterName: 'isDraft', parameterValue: this._myGlobals.selectedDashboardDocument.status == 'Draft' ? 'True' : 'False'  },
      { parameterName: 'FormInstanceID', parameterValue: this.visionHearingDB.iepFormInstanceId.toString() },
      { parameterName: 'ShowCustomWaterMark', parameterValue: this._myGlobals.selectedDashboardDocument.status == 'Draft' ? 'true' : 'false' },
      { parameterName: 'CustomWatermarkText', parameterValue: 'DRAFT DRAFT DRAFT' },
      { parameterName: 'FormVersionID', parameterValue: '' },
      { parameterName: 'BlankForm', parameterValue: 'false' },
      { parameterName: 'IEPID', parameterValue: this.visionHearingDB.iepId.toString() }
    );
  }

  printEnglish() {
    this.populateReportParameters();
    this.printFormCommon(this.visionHearingDB.rdlFileNameEnglish, this.reportParamArray);
  }

  printSpanish() {
    this.populateReportParameters();
    this.printFormCommon(this.visionHearingDB.rdlFileNameSpanish, this.reportParamArray);
  }

}
